type BrandProps = {
  className?: string;
  tone?: "light" | "dark";
  compact?: boolean;
};

/** The shared Beacon by APAS product lockup. The mark stays code-native and crisp at every size. */
export function Brand({ className = "", tone = "dark", compact = false }: BrandProps) {
  return (
    <div className={`beacon-brand ${tone === "light" ? "on-dark" : "on-light"} ${compact ? "compact" : ""} ${className}`.trim()} aria-label="Beacon by APAS">
      <span className="beacon-mark" aria-hidden="true"><span /></span>
      <span className="beacon-lockup">
        <span className="beacon-word">Beacon</span>
        <span className="beacon-by">by APAS</span>
      </span>
    </div>
  );
}
